/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmVerificationDobRequest
 */
export interface ConfirmVerificationDobRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * Calendar date, YYYY-MM-DD
     */
    verification_dob: string;
}

/**
 * Check if a given object implements the ConfirmVerificationDobRequest interface.
 */
export function instanceOfConfirmVerificationDobRequest(value: object): value is ConfirmVerificationDobRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    if (!('verification_dob' in value) || value['verification_dob'] === undefined) return false;
    return true;
}

export function ConfirmVerificationDobRequestFromJSON(json: any): ConfirmVerificationDobRequest {
    return ConfirmVerificationDobRequestFromJSONTyped(json, false);
}

export function ConfirmVerificationDobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmVerificationDobRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'verification_dob': json['verification_dob'],
    };
}

export function ConfirmVerificationDobRequestToJSON(json: any): ConfirmVerificationDobRequest {
    return ConfirmVerificationDobRequestToJSONTyped(json, false);
}

export function ConfirmVerificationDobRequestToJSONTyped(value?: ConfirmVerificationDobRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'verification_dob': value['verification_dob'],
    };
}

